export const getScrollStyles = theme => ({
  scroll: {
    '&::-webkit-scrollbar-thumb': {
      // In dark the mid-grey thumb is near-invisible on the dark track; use a light white-alpha thumb.
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.24)' : theme.palette.grey[500],
      border: '3px solid transparent',
      backgroundClip: 'content-box',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.36)' : theme.palette.grey[600],
      border: '3px solid transparent',
      backgroundClip: 'content-box',
    },
    '&::-webkit-scrollbar-corner': {
      backgroundColor: 'transparent',
    },
  },
});
